import { Box } from "@mui/material";
import "../_style.scss";
import TkDownloadLink from "../../../components/atoms/TkDownloadLink";
import { formClassFacility, FormKbn } from "../../../assets/data/Constants";
function funInfoBodyList(facilityList: any, formList: any) {
  const infoBodyList: any[] = [];
  for (let i in facilityList) {
    const file = formList.find(
      (item: any) =>
        item.formKbn === FormKbn["施設書類"] &&
        item.formClass ===
          formClassFacility["廃止・休止が確認できる書類の添付"] &&
        item.facilityNo === facilityList[i].facilityNo
    );
    const data = [
      {
        children:
          (facilityList[i].facilityNo ?? "") +
          ":" +
          (facilityList[i].facilityName ?? ""),
      },
      {
        children: facilityList[i].reason,
      },
      {
        children: facilityList[i].obsoleteDate,
        align: "center",
      },
      {
        children: (
          <>
            <Box className="context">
              <Box>配置換え</Box>
              <Box>{facilityList[i].rearrangementStaffNum} 人</Box>
            </Box>
            <Box className="context">
              <Box>譲渡先法人へ異動</Box>
              <Box>{facilityList[i].continueTransferStaffNum} 人</Box>
            </Box>
            <Box className="context">
              <Box>退職</Box>
              <Box>{facilityList[i].retirementNo} 人</Box>
            </Box>
            <Box className="context">
              <Box>合計</Box>
              <Box>{facilityList[i].totalNum} 人</Box>
            </Box>
          </>
        ),
      },
      {
        children: facilityList[i].aCorpname,
      },
      {
        children: file ? (
          <TkDownloadLink
            dataname={file.fileName ?? ""}
            base64filedata={file.fileBase64 ?? ""}
            downloadBase64={true}
          ></TkDownloadLink>
        ) : (
          ""
        ),
      },
    ];
    infoBodyList.push(data);
  }

  return infoBodyList;
}

function funMemoBodyList(res: any) {
  const infoBodyList: any[] = [];
  for (let i in res) {
    const data = [
      {
        children: res[i].managerName,
      },
      {
        children: res[i].process,
      },
      {
        children: res[i].createDate,
        align: "center",
      },
      {
        children: res[i].processComment,
      },
    ];
    infoBodyList.push(data);
  }

  return infoBodyList;
}

export { funInfoBodyList, funMemoBodyList };
